import React, { type CSSProperties, useRef } from 'react';

import { Connector } from './Connector';
import type { ConnectorProps } from './Connector';
import { connectorTypesMap } from './connectorTypes';
import { useConnectorDrag } from './useConnectorDrag';
import { useConnectorRegister } from './useConnectorRegister';

export type ExecutionState = { type: string; [key: string]: unknown };

export interface ConnectorTrueProps extends ConnectorProps {
  nodeId: string;
  cardRootRef: React.RefObject<HTMLElement>;
  activeConnectors: Set<string>;
  executionState: ExecutionState;
  positionStyle?: CSSProperties;
  isHovered?: boolean;
  isSelected?: boolean;
  isDisabled?: boolean;
  isDisabledStyle?: string;
  isVisibleOverride?: boolean;
  isDragOverAndCanConnect?: boolean;
}

export function ConnectorTrue(props: ConnectorTrueProps) {
  const circleRef = useRef<SVGCircleElement | null>(null);
  const connectorTrueRef = useRef<HTMLDivElement | null>(null);

  const collectedProps = useConnectorDrag({
    ref: connectorTrueRef,
    type: connectorTypesMap.True,
    nodeId: props.nodeId,
    isDisabled: props.isDisabled,
  });

  useConnectorRegister({
    cardRootRef: props.cardRootRef,
    centerRef: circleRef,
    type: connectorTypesMap.True,
    nodeId: props.nodeId,
    centerRefs: null,
  });

  const isActive = props.activeConnectors.has(`${props.nodeId}::${connectorTypesMap.True}`);
  const isSiblingActive = props.activeConnectors.has(`${props.nodeId}::${connectorTypesMap.False}`);

  return (
    <Connector
      circleRef={circleRef}
      dragHandleRef={connectorTrueRef}
      positionStyle={props.positionStyle}
      connectorType={connectorTypesMap.True}
      executionState={props.executionState}
      isActive={isActive}
      isSiblingActive={isSiblingActive}
      isHovered={props.isHovered}
      isSelected={props.isSelected}
      isDisabled={props.isDisabled}
      isDisabledStyle={props.isDisabledStyle}
      isDragging={collectedProps?.isDragging}
      isVisibleOverride={props.isVisibleOverride}
      isDragOverAndCanConnect={props.isDragOverAndCanConnect}
      direction={props.direction}
      positionYOffset={props.positionYOffset}
    />
  );
}
